<template>
  <div>
    <Navigation />
    <section class="section__container top__container blog__details">
      <h1 class="title center__text">E-TICKET</h1>
      <h2 class="title center__text">
        Nouveau ! L'application Mobile Ticketing remplace votre titre de transport ! <br/>*Prochainement à votre disposition
      </h2>

      <p>
        L'expérience de voyage en bus au Sénégal est souvent source de tracas, avec de
        longues files d'attente aux guichets et des problèmes de sécurité potentiels.
        Heureusement, grâce à l'application Mobile Ticketing, tout cela est désormais révolu !
      </p>

      <p>
        Plus besoin de monnaie ou de tickets, l'application Mobile Ticketing offre une solution 
        pratique et rapide. Vous pouvez acheter et valider votre ticket ou abonnement directement 
        depuis l'application.
      </p>
      <p>
        Services-SMS joue un rôle clé dans la transformation numérique du transport au Sénégal,
        en numérisant les tickets de bus, les événements et les spectacles, ainsi que les guichets
        de ticket de bus pour les trajets interurbains et transnationaux. Cela permet aux voyageurs
        d'acheter leurs "E-Ticket" en peu de temps.
      </p>
  
      <p>
        Notre objectif est d'informatiser les services de transport routier et maritime au Sénégal, 
        en fournissant aux compagnies de transport des outils numériques intelligents pour gérer le 
        trafic et améliorer la mobilité des voyageurs.
      </p>
      <p>
        Servicesms.sn aspire à révolutionner le transport au Sénégal grâce au numérique.
      </p>
      <h3 class="underline">Les avantages de l'e-ticket sont nombreux :</h3>
      <div class="cards spacer-1">
        <div class="card">
          <img
            class="card__image"
            src="/../images/ticketing/tab-mobile.png"
            alt=""
            srcset=""
          />
          <div class="card__details center__text">
            <h3>Mobile</h3>
            <p>
              Obtenez votre e-ticket directement sur votre téléphone, 
              où que vous soyez et quand vous le souhaitez.
            </p>
          </div>
        </div>
        <div class="card">
          <img
            class="card__image"
            src="/../images/ticketing/tab-pratique.png"
            alt=""
          />
          <div class="card__details center__text">
            <h3>Pratique</h3>
            <p>
              Dites adieu à la recherche de monnaie, le prix de votre e-ticket 
              est automatiquement ajouté au montant à payer.
            </p>
          </div>
        </div>
        <div class="card">
          <img
            class="card__image"
            src="/../images/ticketing/tab-rapide.png"
            alt=""
          />
          <div class="card__details center__text">
            <h3>Rapide</h3>
            <p>
              Dites adieu aux files d'attente aux automates, 
              obtenez votre e-ticket en quelques secondes seulement.
            </p>
          </div>
        </div>
      </div>
      <h3 class="underline">Comment obtenir votre e-ticket :</h3>
      
      <li><strong>Procédez au téléchargement de l'application mobile ticketing. </strong></li>
      <li><strong>Inscrivez-vous dès maintenant.</strong></li>
      <li><strong>Sélectionnez votre e-ticket et effectuez le paiement avec votre compte Orange ou Wave.</strong></li>
      <li><strong>Pour valider votre e-ticket, scannez l'un des QR Code à bord des bus ou saisissez manuellement le code indiqué sous le QR code.</strong></li>
      <h3 class="underline">Que se passe-t-il en cas de contrôle ?</h3>
      <li><strong>À chaque validation, un écran de contrôle est généré. Il vous suffit de présenter cet écran au vérificateur.</strong></li>
      <h3>NB :</h3>
      
      Le e-ticket est lié au téléphone qui l'a acheté et ne peut pas être transféré. Il est possible d'acheter
      un e-ticket pour vous-même ainsi que pour des accompagnants, <br/>à condition que tous les voyageurs se déplacent
      ensemble. <br/>Les e-tickets sont valables pendant 1 heure à partir de l'envoi du titre de transport.
      
         
      <h3 class="underline">Pour obtenir plus d'informations</h3>
      <div class="cgvfile">
        <a href="CGVU-E-TICKET.pdf" target="_blank" class="cgvtext"
          >Conditions générales de vente et d'utilisation des E-tickets
          pour le réseau de transport Dakar Dem Dikk (CGVU)
          </a
        >
      </div>
    </section>
    <h2 class="center__text spacer-2">
      Simplifiez vos achats d'e-tickets de bus<br/>
      Faites des économies et voyagez davantage !
    </h2>

    <div class="section__container">
      <div class="center__text">
        <img src="/../images/icone-bus.png" alt="" />

        <h2 slot="title">Guide d'utilisation du service</h2>
      </div>

      <form-wizard
        title=""
        subtitle=""
        color="#0092ff"
      
      >
  <tab-content title="Veuillez remplir les champs ci-dessous pour acheter votre e-ticket." :before-change="beforeTabSwitch">
    <span class="astrix errmessage">    {{message}}</span>
  <form @submit.prevent="checkForm" method="post" >
            <div>
              <label for="compange">COMPAGNIE <span class="astrix">*</span> </label>
              <select name="" id="compange" >
              
                <option value="">DDD</option>
                <option value="">AFTU</option>
               
              
              </select>
            </div>
            <div>
              <label for="">LIGNE <span class="astrix">*</span> </label>
           
              <input v-model.trim="busnumber"  placeholder="numero de bus" type="text" @keypress="validateNumber" name="busnumber" id="" required="required" />
            </div>
            <div>
              <label for="compange"> DÉPART (adresse,arrêt,lieu..)-obligatoire <span class="astrix">*</span> </label>
              <select  id="compange"  v-model="firstinput">
                
            
                  <option value=""  disabled selected>ex: Ouakam</option>

                 <option v-for="item in matchdestinations"  :key="item.id" :value="item"  >
                
                  {{item.start}}
                </option> 
                
              </select>

            
          
              
                  <button class="switch__btn" @click.prevent="switchtext">Inverser</button>

              <label for="compange">ARRIVÉE  (addresse,arrêt,lieu..)-obligatoire <span class="astrix">*</span> </label>
              <select name="" id="compange" v-model="secondinput">
                <option value=""  disabled selected>ex: Grand Mbao</option>
                <option v-for="item in matchdestinations" :key="item.id"  :value="item">
                   {{item.end}}

                </option>
              
              </select>

              <label for="">DATE D’ACHAT </label>
              <input v-model="date" type="date" name="" id="" />
            </div>
            <div>
              <label for="">NOMBRE E-TICKET <span class="astrix">*</span> </label>
              <input  type="text" @keypress="validateNumber" v-model="numberoftickets" />
            </div>

            
          </form>
          
  </tab-content>
  <tab-content title="Identification"  :before-change="()=>beforeSecondTabSwitch(2)">
       <span class="astrix">{{message}}</span>
        <form  @click.prevent>
            <div>
              <label for="">Nom <span class="astrix">*</span> </label>
              <input v-model="name" type="text"  placeholder="Votre nom"  />
              
            </div>
            <div>
              <label for="">Prénom <span class="astrix">*</span> </label>
              <input v-model="surname" type="text"  placeholder="Votre prénom"  />
            </div>
            <div>
              <label for="">E-mail</label>
              <input v-model="email" type="email" name="" placeholder="Votre E-mail" id="" />
            </div>
          </form>
   </tab-content>
   <tab-content title="Suivant"  :before-change="()=>beforeThirdTabSwitch(3)">
            <span class="astrix">{{message}}</span>

    <form @click.prevent>
            <div>
              <label for="">Le montant à régler</label>
              <input type="text" name="" placeholder="CFA" v-model="calculatePrice" id="" disabled/>
            </div>
            <div>
              <label for="">Options de paiement disponibles</label>
              <select name="" id="">
                <option value="">Orange Money</option>
                <option value="">Wave</option>
              </select>
            </div>
            <div>
              <label for="">Numéro de téléphone du compte Orange Money ou Wave <span class="astrix">*</span></label>
              <input v-model="telephone"  @keypress="validateNumber" type="text" name="" placeholder="numéro téléphone" id="" />
            </div>
            <div>
              <label for="">Code mmid <span class="astrix">*</span></label>
              <input v-model="code" type="text" name="" id="" />
            </div>
          </form>
   </tab-content>
</form-wizard>
      
    </div>
      
    <h2 class="center__text">Nous rendons les choses plus faciles pour vous.</h2>
    <div class="cards sixty__container">
      <div class="card">
        <img
          class="card__image"
          src="/../images/ticketing/bus-ter.png"
          alt=""
        />
        <div class="card__details center__text">
          <h3>Obtenez votre e-ticket depuis votre domicile</h3>
          <p>
            Obtenez désormais votre e-ticket depuis le confort de votre domicile.
        
          </p>
        </div>
      </div>
      <div class="card">
        <img
          class="card__image"
          src="/../images/ticketing/Ticket-instantane.png"
          alt=""
        />
        <div class="card__details center__text">
          <h3>Effectuez le paiement avec votre compte Mobile Money.</h3>
          <p>
            Oubliez les soucis de monnaie. Payez avec votre compte Mobile : 
            Orange Money ou Wave et obtenez votre e-ticket. La solution la 
            plus simple et sans stress.
          </p>
        </div>
      </div>

      <div class="card">
        <img
          class="card__image"
          src="/../images/ticketing/Gag-temp.png"
          alt=""
        />
        <div class="card__details center__text">
          <h3>Économisez du temps</h3>
          <p>
            Économisez encore plus de temps en achetant 
            votre e-ticket à l'avance, en seulement quelques secondes !
          </p>
        </div>
      </div>

      <div class="card">
        <img
          class="card__image"
          src="/../images/ticketing/Ticket-delivre-insta.png"
          alt=""
        />
        <div class="card__details center__text">
          <h3>Obtenez votre ticket instantanément</h3>
          <p>Recevez votre e-ticket instantanément.</p>
        </div>
      </div>

      <div class="card">
        <img
          class="card__image"
          src="/../images/ticketing/icone-garantie.png"
          alt=""
        />
        <div class="card__details center__text">
          <h3>Paiement garanti à 100%</h3>
          <p>
            Tout achat d'e-ticket sur notre plateforme mobile 
            ticketing garantit votre voyage avec la compagnie de votre choix.
          </p>
        </div>
      </div>

      <div class="card">
        <img
          class="card__image"
          src="/../images/ticketing/sur-securite.png"
          alt=""
        />
        <div class="card__details center__text">
          <h3>Sécurité garantie</h3>
          <p>
            Tous les paiements sont sécurisés via votre 
            portefeuille électronique mobile.
          </p>
        </div>
      </div>
    </div>
    <h2 class="section__container center__text spacer-2">
      Bientôt disponible sur Google Play Store (pour Android) et l'App Store (pour iOS)
    </h2>

    <h3 class="center__text section__container">
      Mobile Ticketing, une expérience de voyage différente.<br/>
      Simple et pratique, ce service vous emmènera là où vous le souhaitez en quelques clics.<br/>
      Ajoutez-le à vos favoris dès maintenant, ne tardez pas !<br/>
      La ponctualité est notre priorité, nous y travaillons constamment.
    </h3>
    <section class="sixty__container">
      <h1 class="title center__text">Nos partenaires</h1>
      <div class="partners">
        <img
          class="img__responsive partner__image"
          src="/../images/ticketing/logo-aftu.png"
          alt="aftu"
        />
        <img
          class="img__responsive partner__image"
          src="/../images/ticketing/Om-Wave.png"
          alt="Om-Wave"
        />
        <img
          class="img__responsive partner__image"
          src="/../images/ticketing/ddd-200x200.png"
          alt="ddd"
        />
      </div>
    </section>
    <Footer />
  </div>
</template>

<script>
import Vue from "vue";
import Navigation from "./Navigation";
import Footer from "./Footer";
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import VeeValidate from 'vee-validate';

import VScrollLock from 'v-scroll-lock';
Vue.use(VeeValidate)
Vue.use(VScrollLock)




export default {
  data(){
  return{
    
   busnumber:null,
   date:null,
   message:'',
   name:null,
   surname:null,
   telephone:null,
   code:null,
   email:null,
  
  firstinput:'',
    secondinput:'',
    numberoftickets:0,
    currentprice:0,
    places:[
        {linge:2,id:1,start:'Darou', end:'TGW',price:100},
        {linge:2,id:2,start:'Darou', end:'Tally B Magg',price:175},
        {linge:2,id:3,start:'Darou', end:'Usine eaux',price:175},
          {linge:2,id:4, start:'TGW', end:'Darou',price:175},
           {linge:3,id:5, start:'test', end:'test4',price:175},
          

           {linge:2,id:6,start:'TGW',end:'Tally B Magg',price:100},
           {linge:2,id:7,start:'Tally B Magg',end:'Usine eaux',price:175},
            {linge:3,id:8, start:'Tally', end:'Magg',price:500},
            {linge:2,id:9,start:'Usine eaux', end:'Darou',price:200},
             {linge:2,id:10,start:'Darou', end:'Arret NiayeLLobat',price:175},
  
      ]
  }
  },
 
  components: {
    Navigation,
    Footer,
    FormWizard,
    TabContent,
  },
  methods:{
   beforeTabSwitch(){

      window.scrollTo(0, 2400);
   if (this.busnumber == null || this.date == null || this.currentprice ==0 
         ){
        this.message="please fill all fields"
     return false;
   }

   return true
   },
   beforeSecondTabSwitch(){
     console.log(this.name,this.surname)
   if( this.name == null || this.surname == null){
     this.message="please fill all fields"
     return false;
   }
   
     return true
    
  
   },
   beforeThirdTabSwitch(){
     if(this.telephone == null || this.code == null){
            this.message="please fill all fields"
       return false;
     }
     return true;
 
   },
   switchtext(){
  console.log("second input",this.secondinput.end)
     
     const temp = this.firstinput.start;
     this.firstinput.start = this.secondinput.end;
     this.secondinput.end = temp

   },
   validateNumber: (event) => {
      let keyCode = event.keyCode;
      if (keyCode < 48 || keyCode > 57) {
        event.preventDefault();
      }
    },

    checkForm(){
   
   this.$validator.validateAll().then(res=>{
     
   }

   )
    
    
  

    },
  
  
  },
  computed:{
    calculatePrice(){
      this.currentprice = this.firstinput.price;
     return this.numberoftickets * this.currentprice;
      
    },
    matchdestinations(){
      return this.places.filter(p=>{
       return   p.linge == this.busnumber
      })
    }

  }

  
};
</script>

<style lang="scss" scoped>
@import "../assets/base.scss";
.partner__image {
  display: block;
  margin: 2rem auto;
}
label {
  display: block;
  font-weight: bold;
  margin-top: 1rem;
}
.astrix{
  color:red;
}
.underline {
  border-bottom: 3px solid $color-tertiary;
}
input,
select {
  width: 100%;
  display: block;

  box-sizing: border-box;
  border: none;
  color: #555;
  height: 50px;
  background-color: #fff;
  background-image: none;
  border: 1px solid #ccc;
  border-radius: 4px;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  margin-top: 1rem;
}
.switch__btn{
  margin-top: 1rem;
  padding: .5rem;
  color: #fff;
    background: hsl(206, 100%, 50%);
    border: none;
    border-radius: 4px;
    cursor: pointer;
}


.cgvtext {
  text-decoration: none;
  color: $color-black;
 
}
.cgvfile {
 
   padding: .5rem;
   
   border-radius: 4px;
     transition: transform .3s;
  &:hover {
     background: $color-tertiary;
     
        transform: scale(1.1); 
        
     .cgvtext{
       color: $color-white;
     }
  }
}
@media (min-width: 64rem) {
  .top__container{
  margin-top:10rem;
 }
  .partners {
    
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
  }
  form {
    width: 50%;
    margin: 0 auto;
  }
  .underline {
    width: 400px;
  }
  .cgvfile{
   width:70%;
  }
}
</style>
